import { green } from "@ant-design/colors";
import { faCircleCheck, faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Space, Typography } from "antd";
import { useEffect, useState } from "react";

type Props = {
  isAutosaving: boolean
  isSaved: boolean
}

const SavingIndicator = ({ isAutosaving, isSaved }: Props) => {
  const [showSavedIcon, setShowSavedIcon] = useState(false);

  useEffect(() => {
    if (isSaved) {
      setShowSavedIcon(true);
      const timer = setTimeout(() => {
        setShowSavedIcon(false);
      }, 2500);

      return () => clearTimeout(timer);
    }
  }, [isSaved]);

  if(isAutosaving) {
    return <FontAwesomeIcon icon={faSpinnerThird} color={green.primary} spin />
  }

  if(showSavedIcon) {
    return <Space>
    <FontAwesomeIcon icon={faCircleCheck} color={green.primary} />
    <Typography.Text type="secondary">Changes Saved</Typography.Text>
  </Space>
  }

  return <></>
}

export default SavingIndicator